import React, { useEffect, useState, useContext } from "react";
import Layout from "components/sales/layout/layout";
import FormSection from "components/sales/formSection/formSectionNew";
import FileUpload from "components/sales/fileUpload/fileUpload";
import "./required-documents.css";
import { Fragment } from "react";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import {toast } from "react-toastify";
const RequiredDocuments = ({
  match,
  getSiteStage,
  documentUploadUrlPublic,
  documentUrlDataPublic = [],
  siteStageData = [],
  saveStagesDocuments
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fileUploads, setFileUploads] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteStage(match?.params?.site_id);
      setIsLoading(false);
    })();
  }, [getSiteStage, match?.params?.site_id]);
  useEffect(() => {
    if (siteStageData && siteStageData?.required_documents && siteStageData?.required_documents?.data) {
      const initialFileUploads = siteStageData?.required_documents?.data?.map(
        (document) => ({
          id: document?.id,
          name: document?.name,
          description: document?.description,
          is_required: document?.is_required,
          uploads: [{ url: document?.url || "" }],
        })
      );
      setFileUploads(initialFileUploads);
    }
  }, [siteStageData]);
  const saveMomDoc = (url, documentIndex, fileIndex) => {
    setFileUploads((prevUploads) => {
      const updatedFileUploads = [...prevUploads];
      updatedFileUploads[documentIndex].uploads[fileIndex] = { url };
      return updatedFileUploads;
    });
  };
  const addFileUpload = (documentIndex) => {
    setFileUploads((prevUploads) =>
      prevUploads.map((document, index) => {
        if (index === documentIndex) {
          return {
            ...document,
            uploads: [...document.uploads, { url: "" }],
          };
        }
        return document;
      })
    );
  };
  const handleModalHide = () => setIsModal(false);
  
  const removeFileUpload = (documentIndex, fileIndex) => {
    setFileUploads((prevUploads) => {
      const updatedFileUploads = [...prevUploads];
      updatedFileUploads[documentIndex].uploads.splice(fileIndex, 1);
      return updatedFileUploads;
    });
  };
  const handleSubmit = async () => {
    const payload = {
      site_id: match?.params?.site_id,
      data: fileUploads
    }
    const allEmpty = fileUploads.every((file) =>
    file.uploads.every((upload) => !upload.url?.trim())
    );

    if (allEmpty) {
      toast.error("Please upload at least 1 document");
      return;
    }
    setIsLoading(true);
    const res = await saveStagesDocuments(payload);
    console.log(res);
    if (res?.status == true) {
      setIsModal(true);
    } else {
      toast.error(res?.message)
    }
    setIsLoading(false);
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  return (
    <Layout
      title="Upload Required Documents"
      isGoback
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <FormSection title="Required Documents">
        {fileUploads.length > 0 && (
          <div className="document-listing">
            {fileUploads.map((document, docIndex) => (
              <div key={document.id} style={{ marginBottom: "20px" }}>
                <FormSection
                  title={
                    <>
                      {`${docIndex + 1}. ${document.name}`}
                      {/* {document.is_required === 1 && (
                        <span style={{ color: "red" }}> *</span>
                      )} */}
                    </>
                  }
                >
                  {document.description && (
                    <>
                      <span
                        className="d-flex"
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          margin: "5px 0 0",
                          justifyContent: "space-between",
                        }}
                      >
                        {document.description}
                      </span>
                      <div className="mt-5">
                        {document.uploads.map((fileUpload, fileIndex) => (
                          <div key={fileIndex}>
                            <FileUpload
                              id={`addAttachment-${docIndex}-${fileIndex}`}
                              accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                              documentUploadUrl={documentUploadUrlPublic}
                              documentUrlData={documentUrlDataPublic}
                              onChange={(val) =>
                                saveMomDoc(val, docIndex, fileIndex)
                              }
                            >
                              <span className="btn btn-transparent btn-lg">
                                {"Upload Document"}
                              </span>
                            </FileUpload>
                            {document.uploads.length > 1 && (
                              <div
                                className="d-flex"
                                style={{
                                  justifyContent: "flex-end",
                                  gap: "10px",
                                }}
                              >
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeFileUpload(docIndex, fileIndex)
                                  }
                                >
                                  Remove
                                </button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => addFileUpload(docIndex)}
                        >
                          Add
                        </button>
                      </div>
                    </>
                  )}
                </FormSection>
              </div>
            ))}
          </div>
        )}
      </FormSection>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{'Document submitted successfully'}</h5>
          <Link
            to={`${baseUrl}/uploaded-document-list/${match?.params?.site_id}`}
            className="btn btn-primary mb-4"
          >
            {'Back to contract listing'}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};
export default RequiredDocuments;